'use client'
import { Box, Flex, Image, Text } from '@mantine/core'

import { CryptoBasketCoin } from '@/types/invest'
import { parseTimeAgo } from '@/utils/dateFormat'
import { formatPercentageColor } from '@/utils/number/format'

import styles from './styles.module.css'

export interface BasketCardProps {
  title: string
  subtitle?: string
  image?: string
  updatePercentage?: string
  updateTime?: string
  tagIcons?: CryptoBasketCoin[]
  badge?: string
}

export default function BasketCard({
  title,
  image,
  updatePercentage,
  updateTime,
  tagIcons = [],
  badge,
}: BasketCardProps) {
  const period = parseTimeAgo(updateTime || '')
  const changeColor = updatePercentage && formatPercentageColor(parseFloat(updatePercentage))
  const updatePercentageSymbol = updatePercentage && parseFloat(updatePercentage) > 0 ? '+' : ''

  return (
    <Box
      className={styles.basketCard}
      onClick={() => {
        window.open('https://web.crypto.com/signup', '_blank')
      }}
    >
      {/* Badge */}
      {badge && <Box className={styles.badge}>{badge}</Box>}
      {/* Image */}
      {image && (
        <Box className={styles.imageContainer}>
          <Image src={image} alt={title} className={styles.image} />
          <Box className={styles.shadow} />
          <Text variant={'heading2'} className={styles.titleOverlay} truncate>
            {title}
          </Text>
        </Box>
      )}
      {/* Content */}
      <Box className={styles.contentContainer}>
        <Flex className={styles.yieldPeriodContainer}>
          {updatePercentage && (
            <>
              <Text variant="body-emphasis" c={changeColor}>
                {updatePercentageSymbol}
                {updatePercentage}%
              </Text>
              <Text variant="body-number" c="var(--text-secondary)">
                &nbsp;·&nbsp;
              </Text>
            </>
          )}
          {period && (
            <Text
              variant="body-number"
              c="var(--text-secondary)"
            >{`${period.value} ${period.unit}`}</Text>
          )}
        </Flex>
        {tagIcons.length > 0 && (
          <Flex className={styles.tagIconsContainer}>
            {tagIcons.slice(0, 5).map((icon, idx) => (
              <Image key={idx} src={icon.icon_url} alt="tag" className={styles.tagIcon} />
            ))}
            <Text className={styles.tagCount}>+{tagIcons.length}</Text>
          </Flex>
        )}
      </Box>
    </Box>
  )
}
